<template>
  <svg
    xmlns:dc="http://purl.org/dc/elements/1.1/"
    xmlns:cc="http://creativecommons.org/ns#"
    xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
    xmlns:svg="http://www.w3.org/2000/svg"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 373.39264 96.452682"
    version="1.1"
    id="svg8"
  >
    <defs id="defs2">
      <linearGradient id="linearGradient1271">
        <stop style="stop-color:#4be2c7;stop-opacity:1" offset="0" id="stop1267" />
        <stop id="stop1275" offset="0.3124449" style="stop-color:#4be2c7;stop-opacity:1" />
        <stop style="stop-color:#ff705c;stop-opacity:1" offset="1" id="stop1269" />
      </linearGradient>
      <clipPath clipPathUnits="userSpaceOnUse" id="clipPath1210">
        <path
          id="path1212"
          style="display:none;opacity:1;fill:#2f91ff;fill-opacity:0.606276;stroke-width:2.8983;stroke-miterlimit:4;stroke-dasharray:none"
          d="M 4.9164291,4.5800625 14.76137,136.55302 404.64175,107.46866 394.79681,-24.504298 Z M 306.75397,-2.90161 c 0,0 17.43166,-1.2779769 27.96253,-1.4589289 0,0 10.74155,-0.044083 18.41316,2.2162157 0,0 8.44434,1.50360199 16.47262,6.2213321 0,0 5.99966,3.5176665 10.22128,9.1844751 0,0 5.17201,6.013113 6.90154,14.442432 2.27771,8.673954 1.1747,17.669404 1.1747,17.669404 -0.27982,7.606652 -5.68808,15.626118 -5.68808,15.626118 -4.39187,7.510116 -12.67444,12.698412 -12.67444,12.698412 -9.26406,4.896495 -9.79037,5.246508 -22.45484,8.608683 0,0 -16.59461,3.020355 -33.04598,3.964242 l -208.79241,15.602105 -25.515429,1.4114 c 0,0 -10.488564,0.2045 -18.337539,-1.44165 0,0 -8.360344,-1.48918 -15.964041,-4.987033 0,0 -8.058954,-3.874106 -13.799279,-11.234663 0,0 -4.259895,-4.707365 -6.956758,-13.458245 0,0 -2.56634,-8.843837 -1.198276,-18.950668 0,0 2.115436,-12.231497 8.504054,-19.062638 0,0 7.635854,-8.81998 17.505125,-12.604577 0,0 11.965911,-5.638493 25.934856,-6.764308 l 22.923458,-2.040009 z"
        />
        <path
          id="lpe_path-effect1214"
          style="opacity:1;fill:#2f91ff;fill-opacity:0.606276;stroke-width:2.8983;stroke-miterlimit:4;stroke-dasharray:none"
          class="powerclip"
          d="M 32.194934,-1.6001324 H 390.34275 V 109.90693 H 32.194934 Z M 4.9164291,4.5800625 14.76137,136.55302 404.64175,107.46866 394.79681,-24.504298 Z M 306.75397,-2.90161 98.340221,12.740489 75.416763,14.780498 c -13.968945,1.125815 -25.934856,6.764308 -25.934856,6.764308 -9.869271,3.784597 -17.505125,12.604577 -17.505125,12.604577 -6.388618,6.831141 -8.504054,19.062638 -8.504054,19.062638 -1.368064,10.106831 1.198276,18.950668 1.198276,18.950668 2.696863,8.75088 6.956758,13.458245 6.956758,13.458245 5.740325,7.360557 13.799279,11.234663 13.799279,11.234663 7.603697,3.497853 15.964041,4.987033 15.964041,4.987033 7.848975,1.64615 18.337539,1.44165 18.337539,1.44165 l 25.515429,-1.4114 208.79241,-15.602105 c 16.45137,-0.943887 33.04598,-3.964242 33.04598,-3.964242 12.66447,-3.362175 13.19078,-3.712188 22.45484,-8.608683 0,0 8.28257,-5.188296 12.67444,-12.698412 0,0 5.40826,-8.019466 5.68808,-15.626118 0,0 1.10301,-8.99545 -1.1747,-17.669404 -1.72953,-8.429319 -6.90154,-14.442432 -6.90154,-14.442432 C 375.60194,7.5946754 369.60228,4.0770089 369.60228,4.0770089 361.574,-0.64072121 353.12966,-2.1443232 353.12966,-2.1443232 345.45805,-4.4046219 334.7165,-4.3605389 334.7165,-4.3605389 324.18563,-4.1795869 306.75397,-2.90161 306.75397,-2.90161 Z"
        />
      </clipPath>
      <linearGradient
        xlink:href="#linearGradient1271"
        id="linearGradient1273"
        x1="14.703488"
        y1="64.729271"
        x2="388.09613"
        y2="64.729271"
        gradientUnits="userSpaceOnUse"
      />
    </defs>
    <metadata id="metadata5">
      <rdf:RDF>
        <cc:Work rdf:about>
          <dc:format>image/svg+xml</dc:format>
          <dc:type rdf:resource="http://purl.org/dc/dcmitype/StillImage" />
          <dc:title />
        </cc:Work>
      </rdf:RDF>
    </metadata>
    <g transform="translate(-14.703488,-16.502932)" style="display:inline;opacity:1" id="g1166">
      <path
        id="path1164"
        d="M 307.74576,17.502932 95.569899,17.602424 72.208317,17.949601 C 57.981382,18.037751 45.441675,23.032578 45.441675,23.032578 35.164383,26.24081 26.768116,34.923762 26.768116,34.923762 19.784493,41.611575 16.719125,54.318706 16.719125,54.318706 14.570836,64.848159 16.50059,74.357012 16.50059,74.357012 c 2.069373,9.421532 6.026932,14.710637 6.026932,14.710637 5.255519,8.197237 13.121401,12.906751 13.121401,12.906751 7.433687,4.27827 15.78505,6.50234 15.78505,6.50234 7.821842,2.34868 18.455612,2.95679 18.455612,2.95679 l 25.938039,0.51801 212.556286,-0.0281 c 16.72635,0.29822 33.75432,-1.57763 33.75432,-1.57763 13.0752,-2.54422 13.63452,-2.87137 23.38311,-7.29734 0,0 8.77684,-4.809878 13.79029,-12.369038 0,0 6.08105,-8.015409 6.93879,-15.999005 0,0 1.796,-9.380658 0.14518,-18.688321 -1.11437,-9.007162 -5.89625,-15.742074 -5.89625,-15.742074 -3.84594,-6.295432 -9.65441,-10.468482 -9.65441,-10.468482 -7.77142,-5.595443 -16.20668,-7.840627 -16.20668,-7.840627 -7.59591,-2.981136 -18.47353,-3.778128 -18.47353,-3.778128 -10.67492,-0.636338 -28.41897,-0.659863 -28.41897,-0.659863 z"
        style="fill:url(#linearGradient1273);fill-opacity:1;stroke:#000000;stroke-width:2;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
      />
    </g>
    <g transform="translate(-14.703488,-16.502932)" id="layer3" style="display:inline">
      <g
        aria-label="physref"
        transform="rotate(4.2662579)"
        id="text1076"
        style="font-style:normal;font-weight:normal;font-size:104.256px;line-height:1.25;font-family:sans-serif;fill:#000000;fill-opacity:1;stroke:none;stroke-width:2.60642"
        clip-path="url(#clipPath1210)"
      >
        <path
          d="m 86.77762,55.629678 q 0,12.726563 -5.803313,20.413406 -5.752406,7.635937 -15.577312,7.635937 -8.348624,0 -13.490156,-5.803312 V 103.8379 H 37.194934 V 27.580336 h 13.642874 l 0.509063,5.396062 q 5.345156,-6.414187 13.948312,-6.414187 10.181249,0 15.831843,7.534124 5.650594,7.534125 5.650594,20.76975 z M 72.065714,54.560647 q 0,-7.686843 -2.748938,-11.861156 -2.698031,-4.174312 -7.890468,-4.174312 -6.92325,0 -9.519469,5.29425 v 22.551468 q 2.698032,5.446968 9.621281,5.446968 10.537594,0 10.537594,-17.257218 z"
          style="font-style:normal;font-variant:normal;font-weight:bold;font-stretch:normal;font-size:104.256px;font-family:Roboto;-inkscape-font-specification:'Roboto, Bold';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-variant-east-asian:normal;fill:#ff705c;fill-opacity:1;stroke-width:2.60642"
          id="path1190"
        />
        <path
          d="m 110.19449,33.587273 q 5.85422,-7.025062 14.71191,-7.025062 17.919,0 18.17353,20.820655 v 35.27803 h -14.71191 v -34.87078 q 0,-4.734281 -2.03625,-6.974156 -2.03625,-2.290781 -6.77053,-2.290781 -6.46509,0 -9.36675,4.988812 V 82.660896 H 95.482587 V 4.4688988 h 14.711903 z"
          style="font-style:normal;font-variant:normal;font-weight:bold;font-stretch:normal;font-size:104.256px;font-family:Roboto;-inkscape-font-specification:'Roboto, Bold';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-variant-east-asian:normal;fill:#ff705c;fill-opacity:1;stroke-width:2.60642"
          id="path1192"
        />
        <path
          d="m 174.84542,61.840241 10.18125,-34.259905 h 15.78094 l -22.14422,63.63281 -1.22175,2.901656 q -4.9379,10.792128 -16.29,10.792128 -3.20709,0 -6.516,-0.96722 V 92.79124 l 2.23988,0.05091 q 4.17431,0 6.21056,-1.272656 2.08716,-1.272656 3.258,-4.225219 l 1.73081,-4.530656 -19.29347,-55.233279 h 15.83185 z"
          style="font-style:normal;font-variant:normal;font-weight:bold;font-stretch:normal;font-size:104.256px;font-family:Roboto;-inkscape-font-specification:'Roboto, Bold';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-variant-east-asian:normal;fill:#ff705c;fill-opacity:1;stroke-width:2.60642"
          id="path1194"
        />
        <path
          d="m 236.44198,67.439928 q 0,-2.698031 -2.69803,-4.225219 -2.64713,-1.578093 -8.55225,-2.799843 -19.64981,-4.123406 -19.64981,-16.69725 0,-7.330499 6.05784,-12.217499 6.10875,-4.937906 15.93366,-4.937906 10.48668,0 16.74815,4.937906 6.31238,4.937906 6.31238,12.828374 h -14.71191 q 0,-3.156187 -2.03625,-5.192437 -2.03625,-2.087156 -6.36328,-2.087156 -3.71616,0 -5.75241,1.679906 -2.03625,1.679906 -2.03625,4.276125 0,2.4435 2.29079,3.970687 2.34168,1.476281 7.83956,2.596219 5.49787,1.069031 9.26494,2.4435 11.65753,4.276125 11.65753,14.813718 0,7.534125 -6.4651,12.2175 -6.46509,4.632468 -16.69725,4.632468 -6.92325,0 -12.31931,-2.4435 -5.34516,-2.494406 -8.39953,-6.770531 -3.05437,-4.327031 -3.05437,-9.315843 h 13.94831 q 0.20362,3.919781 2.90165,6.006937 2.69803,2.087156 7.22869,2.087156 4.22522,0 6.36328,-1.578093 2.18897,-1.629 2.18897,-4.225219 z"
          style="font-style:normal;font-variant:normal;font-weight:bold;font-stretch:normal;font-size:104.256px;font-family:Roboto;-inkscape-font-specification:'Roboto, Bold';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-variant-east-asian:normal;fill:#ff705c;fill-opacity:1;stroke-width:2.60642"
          id="path1196"
        />
        <path
          d="m 291.11529,41.375929 q -3.00347,-0.40725 -5.29425,-0.40725 -8.34862,0 -10.94484,5.650593 v 36.041624 h -14.71191 v -55.08056 h 13.89741 l 0.40725,6.566906 q 4.42884,-7.585031 12.26841,-7.585031 2.4435,0 4.58156,0.661781 z"
          style="font-style:normal;font-variant:normal;font-weight:bold;font-stretch:normal;font-size:104.256px;font-family:Roboto;-inkscape-font-specification:'Roboto, Bold';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-variant-east-asian:normal;fill:#4be2c7;fill-opacity:1;stroke-width:2.60642"
          id="path1198"
        />
        <path
          d="m 322.57536,83.679021 q -12.11569,0 -19.75163,-7.432312 -7.58503,-7.432312 -7.58503,-19.802531 v -1.425375 q 0,-8.297718 3.2071,-14.813718 3.20709,-6.566906 9.06131,-10.079437 5.90512,-3.563437 13.43925,-3.563437 11.30119,0 17.76628,7.126874 6.516,7.126875 6.516,20.209781 v 6.006937 h -35.07441 q 0.71269,5.396063 4.27613,8.654062 3.61434,3.258 9.11222,3.258 8.50134,0 13.28653,-6.159656 l 7.22869,8.094094 q -3.30891,4.683375 -8.9595,7.3305 -5.6506,2.596218 -12.52294,2.596218 z m -1.67991,-45.204748 q -4.37793,0 -7.12687,2.952562 -2.69803,2.952563 -3.46163,8.450437 h 20.46432 v -1.170843 q -0.10182,-4.887 -2.64713,-7.534125 -2.54531,-2.698031 -7.22869,-2.698031 z"
          style="font-style:normal;font-variant:normal;font-weight:bold;font-stretch:normal;font-size:104.256px;font-family:Roboto;-inkscape-font-specification:'Roboto, Bold';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-variant-east-asian:normal;fill:#4be2c7;fill-opacity:1;stroke-width:2.60642"
          id="path1200"
        />
        <path
          d="M 357.64975,82.660896 V 38.37246 h -8.1959 V 27.580336 h 8.1959 v -4.683375 q 0,-9.264938 5.29425,-14.3555624 5.34516,-5.141531 14.91554,-5.141531 3.05437,0 7.48321,1.0181249 l -0.15271,11.4029995 q -1.83263,-0.458156 -4.47975,-0.458156 -8.29772,0 -8.29772,7.788656 v 4.428844 h 10.94484 V 38.37246 h -10.94484 v 44.288436 z"
          style="font-style:normal;font-variant:normal;font-weight:bold;font-stretch:normal;font-size:104.256px;font-family:Roboto;-inkscape-font-specification:'Roboto, Bold';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-variant-east-asian:normal;fill:#4be2c7;fill-opacity:1;stroke-width:2.60642"
          id="path1202"
        />
      </g>
    </g>
    <g transform="translate(-14.703488,-16.502932)" style="display:inline;opacity:1" id="g1134">
      <g id="g1106">
        <g transform="translate(20.12411,-0.19190443)" id="g1084" style="display:inline">
          <circle
            r="2.0309136"
            cy="55.934711"
            cx="100.29418"
            id="circle1080"
            style="display:inline;opacity:1;fill:#ffffff;fill-opacity:1;stroke-width:3;stroke-miterlimit:4;stroke-dasharray:none"
          />
          <circle
            style="display:inline;opacity:1;fill:#000000;fill-opacity:1;stroke-width:2.48635;stroke-miterlimit:4;stroke-dasharray:none"
            id="circle1082"
            cx="100.56818"
            cy="55.989277"
            r="1.6831883"
          />
        </g>
        <g id="g1090" transform="translate(-5.0506619,-0.18898809)">
          <circle
            style="display:inline;opacity:1;fill:#ffffff;fill-opacity:1;stroke-width:3;stroke-miterlimit:4;stroke-dasharray:none"
            id="circle1086"
            cx="100.29418"
            cy="55.934711"
            r="2.0309136"
          />
          <circle
            r="1.6831883"
            cy="55.989277"
            cx="100.56818"
            id="circle1088"
            style="display:inline;opacity:1;fill:#000000;fill-opacity:1;stroke-width:2.48635;stroke-miterlimit:4;stroke-dasharray:none"
          />
        </g>
        <g id="g1098">
          <g
            style="display:inline;opacity:1"
            id="g1094"
            transform="translate(-5.0722825,19.317762)"
          >
            <circle
              style="display:inline;opacity:1;fill:#ffffff;fill-opacity:1;stroke-width:3;stroke-miterlimit:4;stroke-dasharray:none"
              id="circle1092"
              cx="100.29418"
              cy="55.934711"
              r="2.0309136"
            />
          </g>
          <circle
            r="1.6831883"
            cy="75.307037"
            cx="95.495895"
            id="circle1096"
            style="display:inline;fill:#000000;fill-opacity:1;stroke-width:2.48635;stroke-miterlimit:4;stroke-dasharray:none"
          />
        </g>
        <g transform="translate(20.241818,19.308593)" id="g1104" style="display:inline">
          <circle
            r="2.0309136"
            cy="55.934711"
            cx="100.29418"
            id="circle1100"
            style="display:inline;opacity:1;fill:#ffffff;fill-opacity:1;stroke-width:3;stroke-miterlimit:4;stroke-dasharray:none"
          />
          <circle
            style="display:inline;opacity:1;fill:#000000;fill-opacity:1;stroke-width:2.48635;stroke-miterlimit:4;stroke-dasharray:none"
            id="circle1102"
            cx="100.56818"
            cy="55.989277"
            r="1.6831883"
          />
        </g>
      </g>
      <g id="g1132">
        <g style="display:inline" id="g1112" transform="translate(207.18114,-0.1396444)">
          <circle
            style="display:inline;opacity:1;fill:#ffffff;fill-opacity:1;stroke-width:3;stroke-miterlimit:4;stroke-dasharray:none"
            id="circle1108"
            cx="100.29418"
            cy="55.934711"
            r="2.0309136"
          />
          <circle
            r="1.6831883"
            cy="55.989277"
            cx="100.56818"
            id="circle1110"
            style="display:inline;opacity:1;fill:#000000;fill-opacity:1;stroke-width:2.48635;stroke-miterlimit:4;stroke-dasharray:none"
          />
        </g>
        <g transform="translate(182.00637,-0.13672806)" id="g1118">
          <circle
            r="2.0309136"
            cy="55.934711"
            cx="100.29418"
            id="circle1114"
            style="display:inline;opacity:1;fill:#ffffff;fill-opacity:1;stroke-width:3;stroke-miterlimit:4;stroke-dasharray:none"
          />
          <circle
            style="display:inline;opacity:1;fill:#000000;fill-opacity:1;stroke-width:2.48635;stroke-miterlimit:4;stroke-dasharray:none"
            id="circle1116"
            cx="100.56818"
            cy="55.989277"
            r="1.6831883"
          />
        </g>
        <g id="g1124">
          <circle
            style="display:inline;fill:#ffffff;fill-opacity:1;stroke-width:3;stroke-miterlimit:4;stroke-dasharray:none"
            id="circle1120"
            cx="307.59302"
            cy="75.295563"
            r="2.0309136"
          />
          <circle
            r="1.6831883"
            cy="75.350128"
            cx="307.86703"
            id="circle1122"
            style="display:inline;fill:#000000;fill-opacity:1;stroke-width:2.48635;stroke-miterlimit:4;stroke-dasharray:none"
          />
        </g>
        <g id="g1130">
          <circle
            r="2.0309136"
            cy="75.319351"
            cx="282.2742"
            id="circle1126"
            style="display:inline;opacity:1;fill:#ffffff;fill-opacity:1;stroke-width:3;stroke-miterlimit:4;stroke-dasharray:none"
          />
          <circle
            style="display:inline;fill:#000000;fill-opacity:1;stroke-width:2.48635;stroke-miterlimit:4;stroke-dasharray:none"
            id="circle1128"
            cx="282.55292"
            cy="75.359299"
            r="1.6831883"
          />
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: "ProjectDeckPhysref"
};
</script>

<style scoped lang="scss">
</style>